/*
 * Common enumerations and utilities for types definition and usage.
 */

import React from 'react';
import { AlertOctagon, AlertTriangle, Calendar, Check, ChevronsRight, Clipboard, Loader, Slash } from 'react-feather';
import { StatusType } from '../view/global';

export const inspectionTypes = Object.freeze(['internal', 'external'] as const);
export const inspectionTypesCombined = Object.freeze(['internal', 'external', 'combined'] as const);

export const probabilities = Object.freeze(['low', 'moderate-low', 'moderate', 'moderate-high', 'high'] as const);

export const assetStatus = Object.freeze(['n/a', 'safe', 'moderate', 'critical'] as const);

export const projectStatus = Object.freeze([
    'ready to inspect',
    'in progress',
    'awaiting report',
    'under review',
    'completed',
] as const);

export const projectExtraStatus = Object.freeze([...projectStatus, 'past due', 'planned', 'not planned'] as const);

export const enumToStatusType: { [commonEnum: string]: StatusType } = Object.freeze({
    low: 'info',
    'moderate-low': 'info',
    moderate: 'warning',
    'moderate-high': 'error',
    high: 'error',
    'ready to inspect': 'info',
    'in progress': 'success',
    'awaiting report': 'warning',
    'under review': 'warning',
    // completed: 'strong',
    completed: 'neutral',
    'past-due': 'error',
    'past due': 'error',
    'not-planned': 'error',
    'not planned': 'error',
    forecast: 'light',
    planned: 'neutral',
    'n/a': 'neutral',
    safe: 'info',
    // 'moderate': 'warning',
    critical: 'error',
    'plan updated': 'neutral',
    'not-defined': 'strong',
    'report:not started': 'warning',
    'report:in progress': 'info',
    'report:completed': 'neutral',
});

export const enumToIcon: { [commonEnum: string]: React.ReactNode } = Object.freeze({
    'ready to inspect': React.createElement(Calendar),
    'in progress': React.createElement(ChevronsRight),
    'awaiting report': React.createElement(AlertTriangle),
    'under review': React.createElement(Loader),
    completed: React.createElement(Check),
    'past-due': React.createElement(AlertOctagon),
    'past due': React.createElement(AlertOctagon),
    'not-planned': React.createElement(Slash),
    'not planned': React.createElement(Slash),
    forecast: React.createElement(Slash),
    planned: React.createElement(Clipboard),
    'plan updated': React.createElement(Clipboard),
} as const);

export type TableOrderStatus = {
    key: string;
    direction?: 'ascending' | 'descending';
};
